import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PageHeader, Spin } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { DISPLAY_MODE } from "Constants";
import {
  createComponentStore,
  useStoreActions,
  useStoreState,
} from "easy-peasy";
import FourOThree from "Pages/private/403";
import FourOFour from "Pages/private/404";
import React, { useEffect, useState } from "react";
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import UserStoreModel, { ACTION_TYPES } from "store/models/user";
import { fixDates, GenerateBackPath, isScreenMobile } from "Utils";
import UserForm from "../components/form";

const useStore = createComponentStore(UserStoreModel);

export default function EditUserPage({ ...props }) {
  const [user, setUser] = useState({
    userUnit: null,
    confirmed: true,
    email: null,
    name: "",
    phone: "",
    surname: "",
    locked: false,
  });

  const { abilities } = useStoreState((store) => store.auth);
  const IsAuthorized = AuthCheck(
    abilities,
    AUTH_ACTIONS.WRITE,
    "Kullanıcı Listesi"
  );
  const [store, actions] = useStore();

  const { updateBreadcrumb } = useStoreActions((store) => store.app);

  let { id } = useParams();
  let history = useHistory();
  let match = useRouteMatch();

  const rootPath = GenerateBackPath(match.path, 4);

  useEffect(() => {
    if (id && AuthCheck(abilities, AUTH_ACTIONS.READ, "Kullanıcı Listesi"))
      actions.getUserById({ object: { id: id } });
  }, [id]);

  useEffect(() => {
    if (store.user) {
      updateBreadcrumb({
        object: {
          name: `${store.user.name} ${store.user.surname}`,
          path: match.path,
        },
        index: 2,
      });

      setUser(fixDates(store.user));
    }
  }, [store.user]);

  const IsLoading = (process) => {
    return [ACTION_TYPES.FETCHING_USER].includes(process);
  };

  return store.process === ACTION_TYPES.USER_FETCHED && !store.user ? (
    <FourOFour />
  ) : (
    <>
      <PageHeader
        className={
          isScreenMobile() ? "mobile-customized customized" : "customized"
        }
        backIcon={<FontAwesomeIcon icon={["fas", "chevron-left"]} />}
        onBack={() => {
          history.push(rootPath);
        }}
        title={
          <>
            {`Kullanıcı - ${
              store.process === ACTION_TYPES.FETCHING_USER
                ? "Yükleniyor"
                : IsAuthorized
                ? `${store.user?.name} ${store.user?.surname}`
                : "Erişim Engellendi"
            }`}
          </>
        }
      />
      {IsAuthorized ? (
        <Spin spinning={IsLoading(store.process)}>
          <div style={{ margin: "0 24px" }}>
            <UserForm
              mode={DISPLAY_MODE.EDIT}
              user={user}
              onAfterSuccess={(response) => {
                history.push(
                  `${GenerateBackPath(match.path, 4)}/${response?.id}/detay`
                );
              }}
            />
          </div>
        </Spin>
      ) : (
        <FourOThree />
      )}
    </>
  );
}
